(function ($) {
  'use strict';

  this.TitanDesert = function () {};
}).bind(window)(jQuery);
